var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApplicationSession } from './ApplicationSession';
import { BillingGatewayEnvironment } from './Environment';
import { ErrorHandling, PaymentError } from './ErrorService';
import { Locale, SupportedVendorsList } from '../common/Constants';
import { convertToCents } from '../common/CurrencyConverter';
import { LIB_VERSION } from '../version';
export var PaymentCurrency;
(function (PaymentCurrency) {
    PaymentCurrency["USD"] = "USD";
})(PaymentCurrency || (PaymentCurrency = {}));
var BillingGatewayService = /** @class */ (function () {
    function BillingGatewayService(config) {
        this.billingGatewayEnvironment = new BillingGatewayEnvironment(config.environment, config.region);
        this.config = config;
    }
    BillingGatewayService.prototype.getApplicationSession = function (applicationSessionId, onPaymentSuccess, onPaymentFailure, onProcessing, setErrorDetails, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionEndpointUrl, response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionEndpointUrl = this.billingGatewayEnvironment.getSessionEndpoint(this.config.applicationId, applicationSessionId);
                        return [4 /*yield*/, fetch(sessionEndpointUrl.toString(), {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        if (!response.ok) {
                            throw ErrorHandling(response.status, body === null || body === void 0 ? void 0 : body.message, body === null || body === void 0 ? void 0 : body.bgCode);
                        }
                        try {
                            return [2 /*return*/, this.parseApplicationSessionResponse(body, onPaymentSuccess, onPaymentFailure, onProcessing, setErrorDetails, locale)];
                        }
                        catch (e) {
                            throw new Error("Error parsing application session response: ".concat(e));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // only used for development / by dev
    BillingGatewayService.prototype.createApplicationSession = function (applicationSessionConfig, onPaymentSuccess, onPaymentFailure, onProcessing, setErrorDetails, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionEndpointUrl, response, body, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        sessionEndpointUrl = this.billingGatewayEnvironment.getSessionEndpoint(this.config.applicationId, undefined);
                        return [4 /*yield*/, fetch(sessionEndpointUrl.toString().replace('.public', ''), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: "Basic ".concat(this.config.appAuthKey)
                                },
                                body: JSON.stringify({
                                    billingProgramId: this.config.billingProgramId,
                                    sessionType: 'FORM_ENCRYPTION', // CC
                                    sourceDetails: {
                                        paymentAmount: {
                                            currency: applicationSessionConfig.currency,
                                            amount: convertToCents(applicationSessionConfig.amount) // convert to cents
                                        },
                                        userReference: applicationSessionConfig.userReference,
                                        returnUrl: applicationSessionConfig === null || applicationSessionConfig === void 0 ? void 0 : applicationSessionConfig.returnUrl,
                                        customerId: applicationSessionConfig === null || applicationSessionConfig === void 0 ? void 0 : applicationSessionConfig.customerId
                                    }
                                })
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw ErrorHandling(response.status);
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.parseApplicationSessionResponse(body, onPaymentSuccess, onPaymentFailure, onProcessing, setErrorDetails, locale)];
                    case 3:
                        error_1 = _a.sent();
                        if (error_1 instanceof PaymentError) {
                            throw error_1;
                        }
                        throw ErrorHandling(null, error_1.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BillingGatewayService.prototype.parseApplicationSessionResponse = function (body, onPaymentSuccess, onPaymentFailure, onProcessing, setErrorDetails, locale) {
        var _a, _b;
        try {
            if (!body.vendorName || !SupportedVendorsList.includes(body.vendorName)) {
                throw ErrorHandling(null, "Unsupported vendor for application session: ".concat(body.vendorName));
            }
            var applicationSessionId = body.sessionId;
            var billingToken = body.billingToken;
            var vendorSessionPayload = JSON.parse(atob(body.vendorSessionPayload));
            var metadata = JSON.parse(atob(body.metadata));
            var clientKey = vendorSessionPayload === null || vendorSessionPayload === void 0 ? void 0 : vendorSessionPayload.clientKey;
            var clientToken = vendorSessionPayload === null || vendorSessionPayload === void 0 ? void 0 : vendorSessionPayload.clientToken;
            var supportedCardBrands = ((_b = (_a = vendorSessionPayload === null || vendorSessionPayload === void 0 ? void 0 : vendorSessionPayload.supportedPaymentMethods) === null || _a === void 0 ? void 0 : _a.creditCard) === null || _b === void 0 ? void 0 : _b.brands) || [];
            var applicationSessionConfig = {
                amount: {
                    amount: metadata.amount.amount,
                    currency: metadata.amount.currency
                },
                applicationSessionId: applicationSessionId,
                billingToken: billingToken,
                adyenClientKey: clientKey,
                braintreeClientToken: clientToken,
                supportedCardBrands: supportedCardBrands,
                vendorMerchantId: body.vendorMerchantId,
                enable3DSecure: body.enable3DSecure,
                paymentMethods: vendorSessionPayload.supportedPaymentMethods
            };
            var _locale = locale || Locale.US;
            var callbacks = {
                onPaymentSuccess: onPaymentSuccess,
                onPaymentFailure: onPaymentFailure,
                onProcessing: onProcessing,
                setErrorDetails: setErrorDetails
            };
            return new ApplicationSession(this, body.vendorName, applicationSessionConfig, _locale, callbacks);
        }
        catch (error) {
            if (error instanceof PaymentError) {
                throw error;
            }
            throw ErrorHandling(null, error.message);
        }
    };
    BillingGatewayService.prototype.submitTokenizationIntent = function (applicationSessionConfig, authorizedPaymentInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenizeIntentUrl, body, response, errorBody, results, error_2;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
            return __generator(this, function (_0) {
                switch (_0.label) {
                    case 0:
                        _0.trys.push([0, 5, , 6]);
                        tokenizeIntentUrl = this.billingGatewayEnvironment.getTokenizeIntentEndpoint(this.config.applicationId, applicationSessionConfig.applicationSessionId);
                        body = JSON.stringify({
                            clientSDKVersion: LIB_VERSION,
                            paymentData: {
                                paymentType: authorizedPaymentInfo.paymentType,
                                encryptedCustomerInput: authorizedPaymentInfo.encryptedCustomerInput,
                                supportNative3ds: applicationSessionConfig.enable3DSecure || true,
                                channel: 'PORTAL',
                                billingContact: {
                                    name: {
                                        first: (_b = (_a = authorizedPaymentInfo.billingInformation) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.firstName,
                                        last: (_d = (_c = authorizedPaymentInfo.billingInformation) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.lastName
                                    },
                                    contactInfo: {
                                        email: (_f = (_e = authorizedPaymentInfo.billingInformation) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.email
                                    },
                                    address: {
                                        city: (_h = (_g = authorizedPaymentInfo.billingInformation) === null || _g === void 0 ? void 0 : _g.address) === null || _h === void 0 ? void 0 : _h.city,
                                        country: '',
                                        address1: (_k = (_j = authorizedPaymentInfo.billingInformation) === null || _j === void 0 ? void 0 : _j.address) === null || _k === void 0 ? void 0 : _k.address1,
                                        address2: (_m = (_l = authorizedPaymentInfo.billingInformation) === null || _l === void 0 ? void 0 : _l.address) === null || _m === void 0 ? void 0 : _m.address2,
                                        postCode: (_p = (_o = authorizedPaymentInfo.billingInformation) === null || _o === void 0 ? void 0 : _o.address) === null || _p === void 0 ? void 0 : _p.postalCode,
                                        state: (_r = (_q = authorizedPaymentInfo.billingInformation) === null || _q === void 0 ? void 0 : _q.address) === null || _r === void 0 ? void 0 : _r.stateOrProvince
                                        // TODO: Address line 2 not handled?. What about country?
                                    }
                                },
                                device: {
                                    acceptHeader: (_s = authorizedPaymentInfo.browserInfo) === null || _s === void 0 ? void 0 : _s.acceptHeader,
                                    colorDepth: (_t = authorizedPaymentInfo.browserInfo) === null || _t === void 0 ? void 0 : _t.colorDepth,
                                    language: (_u = authorizedPaymentInfo.browserInfo) === null || _u === void 0 ? void 0 : _u.language,
                                    screenHeight: (_v = authorizedPaymentInfo.browserInfo) === null || _v === void 0 ? void 0 : _v.screenHeight,
                                    screenWidth: (_w = authorizedPaymentInfo.browserInfo) === null || _w === void 0 ? void 0 : _w.screenWidth,
                                    timeZoneOffset: (_x = authorizedPaymentInfo.browserInfo) === null || _x === void 0 ? void 0 : _x.timeZoneOffset,
                                    userAgent: (_y = authorizedPaymentInfo.browserInfo) === null || _y === void 0 ? void 0 : _y.userAgent,
                                    javaEnabled: (_z = authorizedPaymentInfo.browserInfo) === null || _z === void 0 ? void 0 : _z.javaEnabled,
                                    origin: window.location.origin,
                                    ipAddress: undefined // TODO
                                },
                                riskData: authorizedPaymentInfo.riskData
                            }
                        });
                        return [4 /*yield*/, fetch(tokenizeIntentUrl.toString(), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: body
                            })];
                    case 1:
                        response = _0.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        errorBody = (_0.sent());
                        throw ErrorHandling(response.status, errorBody === null || errorBody === void 0 ? void 0 : errorBody.message, errorBody === null || errorBody === void 0 ? void 0 : errorBody.bgCode);
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        results = (_0.sent());
                        results.action = results.action ? results.action : undefined;
                        return [2 /*return*/, results];
                    case 5:
                        error_2 = _0.sent();
                        if (error_2 instanceof PaymentError) {
                            throw error_2;
                        }
                        throw ErrorHandling(null, error_2.message);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BillingGatewayService.prototype.submitPaymentDetails = function (applicationSessionConfig, result) {
        return __awaiter(this, void 0, void 0, function () {
            var submitPaymentDetailsEndpoint, response, responseBody, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        submitPaymentDetailsEndpoint = this.billingGatewayEnvironment.getSubmitPaymentDetailsEndpoint(this.config.applicationId, applicationSessionConfig.applicationSessionId);
                        return [4 /*yield*/, fetch(submitPaymentDetailsEndpoint.toString(), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(result)
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseBody = _a.sent();
                        if (!response.ok) {
                            throw ErrorHandling(response.status, responseBody === null || responseBody === void 0 ? void 0 : responseBody.message, responseBody === null || responseBody === void 0 ? void 0 : responseBody.bgCode);
                        }
                        return [2 /*return*/, responseBody];
                    case 3:
                        error_3 = _a.sent();
                        if (error_3 instanceof PaymentError) {
                            throw error_3;
                        }
                        throw ErrorHandling(null, error_3.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return BillingGatewayService;
}());
export { BillingGatewayService };
